import { useMemo } from 'react'
import { Chains } from '../chains'
import { useWeb3 } from './useWeb3'

export const useBlockExplorerName = () => {
  const { chainId } = useWeb3()

  return useMemo(() => {
    if (chainId === Chains.Polygon || chainId === Chains.Matic) {
      return 'polygonscan'
    }

    return 'etherscan'
  }, [chainId])
}
